export default {
  FULL_DATE: "YYYY-MM-DD",
  YEAR_MONTH: "YYYY-MM",
};
